import { css } from '@emotion/react';

export default {
  flexRow: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }),
  flexColumn: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
  gap2: css({
    gap: 5,
  }),
};
